import React, { FC } from "react";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import styles from './BlockUserModal.module.scss'

interface BlockUserModalProps {
  /** Callback to close modal and cancel block action */
  onClose: () => void;
  onSubmit?: (userIds: any[]) => void;
  isSubmitting?: boolean;
  userId: any;
}
const BlockUserModal: FC<BlockUserModalProps> = ({
  onClose,
  onSubmit,
  isSubmitting,
  userId,
}) => {
 
  const handleConfirm = () => {
    onSubmit?.([userId]);
  };

  /* --------------------------------------------------------------------------
   * Render
   * -------------------------------------------------------------------------- */
  return (
    <div className="create-promotion-modal">
      {/* Full-screen Backdrop */}
      <Backdrop open={true}>
        {/* Modal Container */}
        <div className={styles["modalContainer"]}>
          {/* Modal Title */}
          <h4 className={styles["modalContainer__title"]}>Block User?</h4>

          {/* Confirmation Message */}
          <div className={styles["modalContainer__inputWrapper"]}>
            Are you sure you want to block this user?
          </div>

          {/* Action Buttons Container */}
          <div className={styles["modalContainer__buttonGroup"]}>
            {/* Cancel Button - Closes modal without blocking */}
            <Button
              onClick={onClose}
              className={`${styles["modalContainer__buttonGroup__cancelButton"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isSubmitting} // Disabled during block to prevent cancellation
            >
              Cancel
            </Button>

            {/* Confirm Button - Initiates block process */}
            <Button
              onClick={handleConfirm}
              className={`${styles["modalContainer__buttonGroup__submitButton"]} create-promo-submit-button`}
              variant="contained"
              disabled={isSubmitting} // Disabled during block to prevent duplicate requests
            >
              {/* Show loading spinner during block, otherwise show "Block User" text */}
              {isSubmitting ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Block"
              )}
            </Button>
          </div>
        </div>
      </Backdrop>
    </div>
  );
};

export default BlockUserModal;
